const BreadCrumb = ({ breadcrumbs, size }) => {
  return (
    <>
      <nav aria-label="breadcrumb" className="ms-1 mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a style={{ fontSize: size }} href="/">
              Home
            </a>
          </li>
          {breadcrumbs.map((item, index) => (
            <li
              key={item._id}
              className={`breadcrumb-item ${
                index === breadcrumbs.length - 1 ? "active" : ""
              }`}
              aria-current={
                index === breadcrumbs.length - 1 ? "page" : undefined
              }
            >
              {index === breadcrumbs.length - 1 ? (
                <a style={{ fontSize: size  }}>{item.name}</a>
              ) : (
                <a
                  style={{ fontSize: size  }}
                  href={`/category/${item._id}`}
                >
                  {item.name}
                </a>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default BreadCrumb;
